// extracted by mini-css-extract-plugin
module.exports = {"banner":"ob_DxKHsN","container":"ob_40oKl2","label":"ob_w9s4wC","entityCard":"ob_7RUtVW","cta":"ob_PDj9hK"};